var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo && _vm.logo.signedBlobId)?_c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo.url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }